// extracted by mini-css-extract-plugin
export default {"fullscreen":"Fd7V3"};